import EnumDataSource from "../utils/enum-data-source.util";

export const APPOINTMENT_OUTCOME_REASON_CONVERTED = 1;
export const APPOINTMENT_OUTCOME_REASON_NOT_CONVERTED = 2;
export const APPOINTMENT_OUTCOME_REASON_EXCLUDED = 3;

const appointmentOutcomeReasonTypes = {
  [APPOINTMENT_OUTCOME_REASON_CONVERTED]: "Converted",
  [APPOINTMENT_OUTCOME_REASON_NOT_CONVERTED]: "Not Converted",
  [APPOINTMENT_OUTCOME_REASON_EXCLUDED]: "Excluded",
};

export const APPOINTMENT_OUTCOME_REASON_TYPES = new EnumDataSource(
  appointmentOutcomeReasonTypes
);

export const APPOINTMENT_OUTCOME_REASON_RESCHEDULED = 4;
export const APPOINTMENT_OUTCOME_REASON_DECLINED = 5;
export const APPOINTMENT_OUTCOME_REASON_NO_ANSWER = 6;

const appointmentCancellationOutcomeReasonTypes = {
  [APPOINTMENT_OUTCOME_REASON_RESCHEDULED]: "Rescheduled",
  [APPOINTMENT_OUTCOME_REASON_DECLINED]: "Declined",
  [APPOINTMENT_OUTCOME_REASON_NO_ANSWER]: "No Answer",
};

export const APPOINTMENT_CANCELLATION_OUTCOME_REASON_TYPES = new EnumDataSource(
  appointmentCancellationOutcomeReasonTypes
);

export const APPOINTMENT_OUTCOME_REASON_ALL_TYPES = new EnumDataSource({
  ...appointmentOutcomeReasonTypes,
  ...appointmentCancellationOutcomeReasonTypes,
});
